/* eslint-disable vue/no-v-html */
<template>
  <div class="text-xs relative flex flex-col" @mouseleave="hideTooltip">
    <div class="bg-white flex items-center h-6">
      <div
        class="w-48 sm:w-[28rem] h-24 flex-shrink-0 px-2 py-1 whitespace-nowrap font-medium hover:text-gray-900 hover:font-bold truncate sticky left-0 bg-white z-20"
      ></div>
      <div class="heat-map-row ml-2 flex-grow-0">
        <div
          v-for="(cat, i) in categories"
          :key="i"
          class="heat-map-head-square"
          :class="{
            'rotate-right': rotateHeaders && rotateRight,
            'rotate-left': rotateHeaders && !rotateRight,
            wide: wide,
          }"
          @mouseenter="showHeaderTooltip($event, cat.id || cat)"
          @mouseleave="showHeaderTooltip(null)"
        >
          <div class="flex items-center">
            <!-- <CountryFlag :iso="cat.id" class="w-5 mr-1" v-if="cat.id" /> -->
            {{ $t(cat.name || cat) }}
          </div>
        </div>
      </div>
    </div>

    <transition-group name="flip-list" tag="div" class="bg-white" appear>
      <div
        v-for="row in data"
        :key="row.name"
        class="flex items-center group h-6 mb-px whitespace-nowrap"
        :class="{ [rowClass]: true }"
        @click="$emit('select', row)"
      >
        <div
          class="w-48 sm:w-[28rem] flex-shrink-0 px-2 py-1 whitespace-nowrap font-medium hover:text-gray-900 hover:font-bold truncate group-hover:bg-gray-100 sticky left-0 bg-white z-20"
          :class="{ [selectedClass]: selected === row.id }"
        >
          <strong v-if="row.num" class="inline-block w-4 text-right mr-2">{{
            `${row.num} `
          }}</strong
          >{{ $t(row.name) }}
        </div>
        <div
          class="heat-map-row ml-2 flex-grow-0 z-10"
          @mouseleave="hideTooltip"
        >
          <div
            v-for="(col, i) in row.values"
            :key="i"
            class="heat-map-square"
            :class="{ [mustHide(col)]: true, wide: wide }"
            :style="{
              'background-color': color(col),
            }"
            @mouseenter="showTooltip($event, row, i)"
          >
            <font-awesome-icon
              v-if="showIcons"
              :icon="['fas', icon(col)]"
              class="text-white opacity-50"
            />
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import colors from "@/utils/colors";
// import CountryFlag from "@/components/CountryFlag";

export default {
  // components: { CountryFlag },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    colorRange: {
      type: Array,
      default: () => ["#ffffff", "#000000"],
    },
    rotateHeaders: {
      type: Boolean,
      default: false,
    },
    rotateRight: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
    selectedClass: {
      type: String,
      default: "bg-gray-200",
    },
    colorScale: {
      type: Function,
      default: null,
    },
    showIcons: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: Number,
      default: null,
    },
    rowClass: {
      type: String,
      default: "",
    },
    wide: {
      type: Boolean,
      default: false,
    },
    thresholds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      regionId: null,
      tooltip: {
        show: false,
        value: "",
        title: "",
        target: null,
        iso: null,
      },
      orderBy: null,
      orderDir: true,
    };
  },
  computed: {},
  methods: {
    color(val) {
      if (this.showIcons) {
        if (val === "n/a") return colors.gray[300];
        if (![0, 1].includes(val)) return colors.policy1;
      }
      return this.colorScale(val);
    },
    showTooltip(event, data, i) {
      this.$emit("hover", { event, data, i });
    },
    hideTooltip() {
      this.$emit("hover", null);
    },
    showHeaderTooltip(event, data) {
      this.hideTooltip();
      if (!event) this.$emit("hoverCat", null);
      else this.$emit("hoverCat", { event, data });
    },
    icon(val) {
      switch (val) {
        case 1:
          return "check";
        case 0:
          return "times";
        case "n/a":
          return "question";
        default:
          return "check";
      }
    },
    mustHide(val) {
      if (this.highlight === null) return "";

      let hide = "opacity-10";

      if (val >= this.highlight && val < this.highlight + 25) hide = "";
      return hide;
    },
  },
};
</script>

<style>
/* @layer components { */
.heat-map-row {
  @apply flex flex-grow h-full space-x-px;
}
.heat-map-square {
  @apply h-full w-5 sm:w-6 justify-center text-center whitespace-nowrap transition-colors duration-300 flex items-center;
}
.heat-map-head-square {
  @apply w-5 sm:w-6 flex flex-grow items-center px-0 py-0 text-xs whitespace-nowrap font-bold transform overflow-x-visible justify-center;
}
.heat-map-head-square.active {
  @apply text-gray-900;
}
.heat-map-head-square.rotate-right {
  /* @apply rotate-45 -translate-x-1/2 origin-right justify-end; */
  @apply -rotate-45 translate-x-1/2 origin-left justify-start;
}
.heat-map-head-square.rotate-left {
  @apply rotate-45 -translate-x-1/2 origin-right justify-end;
  /* @apply -rotate-45 translate-x-1/2 origin-left justify-start; */
}

.heat-map-head-square.wide,
.heat-map-square.wide {
  @apply w-8;
}
</style>
